import { render, staticRenderFns } from "./ConditionCaseChannelType.vue?vue&type=template&id=bdc8e18e&"
import script from "./ConditionCaseChannelType.vue?vue&type=script&lang=js&"
export * from "./ConditionCaseChannelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports